import Validator from 'validatorjs'
import formatErrors from './formatErrors'
import {convertYearToJalali, matchableDates} from './dateHelper'

let rules = {
  death_date: 'required|integer|min:1900',
  death_date_fa: 'required|integer'
}

Validator.register('jalaliYearRange', (value, gregorianYear) => {
  return matchableDates(value, gregorianYear)
}, 'سال جلالی با میلادی تطبیق ندارد')

const makeRules = (values) => {
  let born = values.bornOn
  let thisYear = new Date().getFullYear()
  return {
    death_date: `required|integer|min:${born}|max:${thisYear}`,
    death_date_fa: `required|integer|min:${convertYearToJalali(born)}|max:${convertYearToJalali(thisYear)}`
  }
}

export default function validateDieReport (values, state, props) {
  if (props) {
    rules = makeRules({...values, bornOn: props.bornOn})
  }
  const validator = new Validator(values, rules, {
    required: 'این فیلد الزامی است',
    integer: 'این فیلد می بایست عدد باشد',
    max: {
      numeric: 'مقدار این فیلد نباید بیشتر از :max باشد'
    },
    min: {
      numeric: 'مقدار این فیلد نباید کمتر از :min باشد'
    }
  })
  validator.passes()
  return formatErrors(validator.errors.all())
}



// WEBPACK FOOTER //
// ./src/utils/validateDieReport.js